import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { observer } from 'mobx-react';
import GdsUiState from '~/glm/models/gds/gds-ui-state';
import UserStore from '~/glm/models/user-store';
import AnalyticsStore from '~/glm/models/analytics-store';
import GdsHouseholdCollection from '~/glm/models/gds/gds-household-collection';
import EventCollection from '~/glm/models/gds/event-collection';
import IndividualGuestList from '~/glm/components/guest-list/individual-guest-list';
import HouseholdList from '~/glm/components/guest-list/household-list';

const groupByGuests = ({ filter, rsvpFilter, mealFilter, sort }) =>
  filter || rsvpFilter || mealFilter || sortByGuest(sort);
const groupByHousehold = ({ filter, rsvpFilter, mealFilter, sort }) =>
  !filter && !rsvpFilter && !mealFilter && (!sort.direction || sortbyHousehold(sort));
const sortByGuest = sort => sort.direction && sort.attribute === 'lastName';
const sortbyHousehold = sort => sort.attribute === 'partySize';

@observer
class GuestListView extends Component {
  state = {
    grouping: 'household',
  };

  setMealColumnVisibility() {
    const { gdsUiState } = this.props;
    const { selectedEvent } = gdsUiState;

    const isMealColumnVisible = gdsUiState.isSelectedEventColumnVisible('Meal');
    const numOfMeals = get(selectedEvent, ['mealQuestion', 'options', 'length']);

    if ((numOfMeals && !isMealColumnVisible) || (!numOfMeals && isMealColumnVisible)) {
      gdsUiState.toggleSelectedEventColumnVisible('Meal');
    }
  }

  checkForFilter = () => {
    const { gdsUiState } = this.props;
    const { grouping } = this.state;

    if (grouping === 'household' && groupByGuests(gdsUiState)) {
      this.setState({ grouping: 'guest' });
    } else if (grouping === 'guest' && groupByHousehold(gdsUiState)) {
      this.setState({ grouping: 'household' });
    }
  };

  getIndividualGuests = () => {
    const { gdsUiState } = this.props;
    const { selectedEvent, addressFilter, filteredHouseholds } = gdsUiState;
    const guests = [];

    if (selectedEvent) {
      selectedEvent.getFilteredAndInvitedHouseholds(addressFilter).forEach(household => {
        const filteredGuests = household.members.filter(guest =>
          guest.getInvitationByEvent(gdsUiState.selectedEvent.id)
        );
        guests.push(...filteredGuests);
      });
    } else {
      filteredHouseholds.forEach(household => {
        const members = household.getMembers;
        guests.push(...members);
      });
    }

    return guests;
  };

  render() {
    const {
      gdsHouseholds,
      gdsEvents,
      gdsUiState,
      userStore,
      analyticsStore,
      handleEditHousehold,
      handleTrackInviteSend,
      handleTrackMeal,
      handleTrackThankYou,
      usesQuestions,
    } = this.props;
    const { grouping } = this.state;

    this.setMealColumnVisibility();
    this.checkForFilter();

    if (grouping === 'guest') {
      const guests = this.getIndividualGuests();

      return (
        <IndividualGuestList
          guests={guests}
          gdsEvents={gdsEvents}
          gdsHouseholds={gdsHouseholds}
          editHousehold={handleEditHousehold}
          trackInviteSend={handleTrackInviteSend}
          trackMeal={handleTrackMeal}
          trackThankYou={handleTrackThankYou}
          analyticsStore={analyticsStore}
          usesQuestions={usesQuestions}
        />
      );
    } else if (grouping === 'household') {
      return (
        <HouseholdList
          userStore={userStore}
          gdsUiState={gdsUiState}
          gdsEvents={gdsEvents}
          gdsHouseholds={gdsHouseholds}
          editHousehold={handleEditHousehold}
          trackInviteSend={handleTrackInviteSend}
          trackMeal={handleTrackMeal}
          trackThankYou={handleTrackThankYou}
          analyticsStore={analyticsStore}
          usesQuestions={usesQuestions}
        />
      );
    }

    return null;
  }
}

GuestListView.propTypes = {
  userStore: PropTypes.instanceOf(UserStore).isRequired,
  gdsUiState: PropTypes.instanceOf(GdsUiState).isRequired,
  gdsHouseholds: PropTypes.instanceOf(GdsHouseholdCollection),
  gdsEvents: PropTypes.instanceOf(EventCollection),
  usesQuestions: PropTypes.bool.isRequired,
  analyticsStore: PropTypes.instanceOf(AnalyticsStore).isRequired,
  handleEditHousehold: PropTypes.func.isRequired,
  handleTrackInviteSend: PropTypes.func.isRequired,
  handleTrackThankYou: PropTypes.func.isRequired,
  handleTrackMeal: PropTypes.func.isRequired,
};

export default GuestListView;
